import * as React from 'react';
import {createRoot} from 'react-dom/client';

import * as screenTypes from './constants/ScreenTypes';
import {initTextConsts} from './constants/TextConst';

import {screensStore} from './_legacy/Screens/ScreensStore';
import ScreensPanel from './_legacy/components/Panels/ScreensPanel';
import {screenActions} from './_legacy/Screens/Common/actions/Screen';
import {designScreenActions} from './_legacy/Screens/Design/actions/Screen';
import {systemReportScreenActions} from './_legacy/Screens/SystemReport/actions/Screen';
import {templatesScreenActions} from './_legacy/Screens/TemplateReport/actions/Screen';
import {containersScreenActions} from './_legacy/Screens/Containers/actions/Screen';
import {packagesScreenActions} from './_legacy/Screens/Packages/actions/Screen';
import {renderFooterPanel} from './_legacy/FormFooter/FormFooter.root';
import {renderActiveScreens} from './_legacy/ActiveScreens/ActiveScreens.root';
import {renderHeaderPanel} from './_legacy/FormHeader/FormHeader.root';
import {renderEmptyState} from './components/Common/EmptyState/EmptyState.root';
import {renderMessageModal} from './_shared/Messages/components/Messages.root';
import {renderToastModal} from './components/Toast/component/Toast.root';
import {renderPrintDialog} from './features/PrintDialog/components/PrintDialog';
import {publishFuncs} from './_shared/GWTBridge/export';
import {renderFilterIcon} from './_legacy/Filters/index';
import {renderDropdown} from './_legacy/Filters/components/FilterDropdown.root';
import {renderSearch} from './_legacy/FieldSearch/components/FormSearch.root';
import {renderProcSearch} from './_legacy/FieldSearch/components/ProcSearch.root';
import {renderEmailVerification} from './features/EmailVerification/EmailVerification.root';
import {renderMultiCompDialog} from './_legacy/MultiCompaniesDialog/components/MultiCompaniesDialog.root';
import {renderEdiCompDialog} from './_legacy/EDICompaniesDialog/components/EDICompaniesDialog.root';
import './styles/index.scss';
import {getServerTexts} from './_legacy/Screens/TemplateReport/texts';
import {renderSelectListModal} from './components/Common/SelectListModal/SelectListModal.root';
import {renderFeaturePopover} from './features/FeaturePopover/FeaturePopover.root';
import {renderHelpPopover} from './_shared/Help/Help.root';
import {renderFormHelpDialog} from './_shared/Help/components/FormHelpDialog';
import {renderLabelSettingsModal} from './components/Common/FormLabel/components/LabelSettingsModal/LabelSettigsModal';
import {renderOnboardingDialog} from './features/OnboardingDialog/Onboarding.root';
import {renderPersonalizationDialog} from './features/Personalization/components/PersonalizationDialog.root';
import {renderMacroDialog} from './_legacy/Macro/components/MacroDialog';
import {renderMacroFooter} from './_legacy/Macro/components/MacroFooter/MacroFooter.root';
import {renderOfflineAlert} from './components/Offline/OfflineAlert';
import {renderReportsDialog} from './features/ReportsDialog/components/ReportsDialog.root';
import {renderPersonalizationSearchesDialog} from './features/Personalization/components/PersonalizationSearchesDialog.root';
import {renderPersonalizationCenter} from './features/Personalization/components/PresonalizationCenter.root';
import {publishNewApi} from './features/Form/export';
import {renderScreenWrapper} from './features/Form/FormScreen.root';
import {setupBaseUrl, setupOdbcBaseUrl} from './services/proto/core/server';
import {activateOIDCWorker, clearStaleState} from './services/webWorkerService';
import {renderAnalytics} from './features/ReportGenerator';
import {renderAnalyticsButton} from './features/ReportGenerator/componenets/AnalyticsButton/AnalyticsButton.root';
import {publishReportsGenerator} from './features/ReportGenerator/export';
import {renderAnnouncementDialog} from './features/Announcement/Annoouncements.root';
import {renderToDoListWidget} from './features/ToDoList/components/Portlet.root';
import {initWASM} from './services/wasm/apiService';
import {renderEOYWizard} from './features/EOYWizard/EOYWizard.root';
import {renderAnalyticsReportsDialog} from './features/AnalyticsReportsDialog/AnalyticsReportsDialog.root';
import {initFusionCharts} from './features/ReportGenerator/componenets/Chart.root';
import {renderBluesnapDialog} from './features/BluesnapDialog/BluesnapDialog.root';
import {renderEOYReminders} from './features/EOYWizard/Components/Reminders/EOYReminders.root';
import {renderADPDialog} from './features/AdvanceDeliveryPlanning/ADP.root';
import {renderHomepage} from './features/Homepage/roots/Homepage.root';
import {renderHPDialogs} from './features/Homepage/roots/HomepageDialogs.root';
import {renderCompanyDlg} from './features/SelectCompanyDlg/SelectCompanyDlg.root';

const compMap = {
    sidePanel: 'P',
    footerPanel: 'FP',
    activeScreens: 'AS',
    headerPanel: 'HP',
    emptyState: 'ES',
    messageModal: 'M',
    reactFilter: 'F',
    filtersDropdown: 'D',
    toastModal: 'T',
    searchDropdown: 'S',
    emailVerification: 'EV',
    procDropdown: 'PS',
    printModal: 'A',
    multiCompModal: 'MC',
    selectListModal: 'SL',
    featurePopover: 'FO',
    helpPopover: 'HO',
    formHelpDlg: 'FH',
    labelSettingsModal: 'LS',
    EdiComdal: 'EDI',
    personalizationDialog: 'PD',
    macroModal: 'MM',
    macroFooter: 'MF',
    offlineModal: 'OM',
    ReportsDialog: 'RD',
    onboardingDialog: 'OD',
    PersonalizationSearchesDialog: 'SPD',
    screen: 'SCR',
    analytics: 'RG',
    PersonalizationCenter: 'PC',
    analyticsButton: 'RGB',
    AnnouncementDialog: 'AD',
    ToDoListPortlet: 'TDL',
    eoyWizard: 'EOY',
    AnalyticsReportsDialog: 'ARD',
    bluesnapDialog: 'BSD',
    eoyReminder: 'EOYR',
    reactHomepageMenu: 'RHM',
    adpDialog: 'ADP',
    sidebarButtons: 'SB',
    homepageDialogs: 'RHD',
    selectCompanyDlg: 'SCD'
};

const renderMap = {
    [compMap.eoyReminder]: renderEOYReminders,
    [compMap.sidePanel]: renderScreen,
    [compMap.footerPanel]: renderFooterPanel,
    [compMap.activeScreens]: renderActiveScreens,
    [compMap.headerPanel]: renderHeaderPanel,
    [compMap.emptyState]: renderEmptyState,
    [compMap.messageModal]: renderMessageModal,
    [compMap.toastModal]: renderToastModal,
    [compMap.printModal]: renderPrintDialog,
    [compMap.multiCompModal]: renderMultiCompDialog,
    [compMap.EdiComdal]: renderEdiCompDialog,
    [compMap.selectListModal]: renderSelectListModal,
    [compMap.reactFilter]: renderFilterIcon,
    [compMap.filtersDropdown]: renderDropdown,
    [compMap.searchDropdown]: renderSearch,
    [compMap.emailVerification]: renderEmailVerification,
    [compMap.procDropdown]: renderProcSearch,
    [compMap.featurePopover]: renderFeaturePopover,
    [compMap.helpPopover]: renderHelpPopover,
    [compMap.formHelpDlg]: renderFormHelpDialog,
    [compMap.labelSettingsModal]: renderLabelSettingsModal,
    [compMap.personalizationDialog]: renderPersonalizationDialog,
    [compMap.macroModal]: renderMacroDialog,
    [compMap.macroFooter]: renderMacroFooter,
    [compMap.offlineModal]: renderOfflineAlert,
    [compMap.ReportsDialog]: renderReportsDialog,
    [compMap.onboardingDialog]: renderOnboardingDialog,
    [compMap.PersonalizationSearchesDialog]: renderPersonalizationSearchesDialog,
    [compMap.screen]: renderScreenWrapper,
    [compMap.analytics]: renderAnalytics,
    [compMap.analyticsButton]: renderAnalyticsButton,
    [compMap.PersonalizationCenter]: renderPersonalizationCenter,
    [compMap.AnnouncementDialog]: renderAnnouncementDialog,
    [compMap.ToDoListPortlet]: renderToDoListWidget,
    [compMap.eoyWizard]: renderEOYWizard,
    [compMap.AnalyticsReportsDialog]: renderAnalyticsReportsDialog,
    [compMap.bluesnapDialog]: renderBluesnapDialog,
    [compMap.reactHomepageMenu]: renderHomepage,
    [compMap.adpDialog]: renderADPDialog,
    [compMap.homepageDialogs]: renderHPDialogs,
    [compMap.selectCompanyDlg]: renderCompanyDlg
};

const roots = {};

export async function renderComponent(compName, selector, props?) {
    if (renderMap[compName]) {
        const root =
            roots[selector] || createRoot(document.getElementById(selector) as HTMLElement);
        roots[selector] = root;

        const ref = await renderMap[compName](root, {...props, selector});
        return ref;
    }
}

export function unmountComponent(selector: string) {
    roots[selector]?.unmount();
    roots[selector] = null;
}

let panelActions;

function initFuncs(screenType, funcs) {
    let thisPanelActions;
    switch (screenType) {
        case screenTypes.design.TREE:
        case screenTypes.design.COLUMNS:
        case screenTypes.design.ACTIVATIONS:
        case screenTypes.menu.MAINMENU:
        case screenTypes.menu.PERSONALMENU:
        case screenTypes.design.SUBLEVELS: {
            designScreenActions.initFunctions(funcs);
            thisPanelActions = designScreenActions;
            break;
        }
        case screenTypes.report.SYSTEMFORMATS: {
            systemReportScreenActions.initFunctions(funcs);
            thisPanelActions = systemReportScreenActions;
            break;
        }
        case screenTypes.report.TEMPLATES: {
            templatesScreenActions.initFunctions(funcs);
            thisPanelActions = templatesScreenActions;
            break;
        }
        case screenTypes.report.CONTAINERS: {
            containersScreenActions.initFunctions(funcs);
            thisPanelActions = containersScreenActions;
            break;
        }
        case screenTypes.design.PACKAGES: {
            packagesScreenActions.initFunctions(funcs);
            thisPanelActions = packagesScreenActions;
            break;
        }
        default: {
            break;
        }
    }
    panelActions = {...screenActions, ...thisPanelActions};
}

async function renderScreen(root, props?) {
    const {screens, funcs, selectedScreenKey} = props;

    if (screensStore.initialized) {
        const {selectedScreen} = screensStore;
        initFuncs(selectedScreen.name, funcs);
        panelActions.insertFields(selectedScreen, screens[selectedScreenKey]);
        panelActions.updateScreen &&
            panelActions.updateScreen(selectedScreen, screens[selectedScreenKey]);
        selectedScreen.setLoading(false);
    } else {
        initTextConsts(funcs);
        await getServerTexts();
        // clean previous session
        screensStore.clearScreens();
        screensStore.initScreens(screens);
        screensStore.setSelectedScreenKey(selectedScreenKey);

        const {selectedScreen} = screensStore;
        initFuncs(selectedScreen.name, funcs);

        panelActions.insertFields(selectedScreen, screens[selectedScreenKey]);
        const comp = (
            <ScreensPanel
                screensStore={screensStore}
                {...props}
                changeScreen={panelActions.changeScreen}
                handleSave={panelActions.saveData}
                className={screens[selectedScreenKey].isSplitted && 'wide'}
            />
        );

        root.render(comp);
    }
}

(async () => {
    publishFuncs();
    publishNewApi();
    setupBaseUrl();
    setupOdbcBaseUrl();
    activateOIDCWorker();
    publishReportsGenerator();
    clearStaleState();
    initWASM();
    initFusionCharts();
})();
